module.exports = __webpack_public_path__ + "static/media/question-circle-hover.56eadba2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-page/question-circle-hover.svg
// module id = 58
// module chunks = 0